import { Messages } from '../../../../gen-src/Localize';
import { DatabaseServerOrPathFragment, DatabaseServerOrPathFragment_CloudFile } from '../../../../gen-src/queries/DatabaseServerOrPathFragment';
import { assertUnreachable } from '../../utils/TypescriptHelpers';

export function createServerOrPathString(database: DatabaseServerOrPathFragment): string {
  switch (database.__typename) {
    case 'CloudFile':
      return getStringForCloudFile(database);
    case 'DatabaseServer':
      // Values can be null or undefined. When values are null, that means that the value has been obfuscated. When the value is undefined
      // that means the attribute doesn't exist. We need to handle both of those cases here.
      if (database.name === undefined && database.hostName === undefined) {
        return '';
      } else if (database.name === undefined && database.hostName !== undefined) {
        // We return the full permissions required string if hostName is null for obfuscation
        return database.hostName !== null ? database.hostName : Messages.DatabaseWithHostname({
          databaseName: Messages.PermissionRequired(),
          databaseHostName: Messages.PermissionsRequired()
        });
      } else if (database.name !== undefined && database.hostName === undefined) {
        // We return the full permissions required string if name is null for obfuscation
        return database.name !== null ? database.name : Messages.DatabaseWithHostname({
          databaseName: Messages.PermissionRequired(),
          databaseHostName: Messages.PermissionsRequired()
        });
      } else {
        return Messages.DatabaseWithHostname({
          databaseName: database.name !== null ? database.name : Messages.PermissionsRequired(),
          databaseHostName: database.hostName !== null ? database.hostName : Messages.PermissionsRequired()
        });
      }
    case 'File':
      // Values can be null or undefined. When values are null, that means that the value has been obfuscated. When the value is undefined
      // that means the attribute doesn't exist. We need to handle both of those cases here.
      if (database.filePath === undefined) {
        return '';
      }
      return database.filePath !== null ? database.filePath : Messages.PermissionsRequired();
    case 'WebDataConnector':
      // Values can be null or undefined. When values are null, that means that the value has been obfuscated. When the value is undefined
      // that means the attribute doesn't exist. We need to handle both of those cases here.
      if (database.connectorUrl === undefined) {
        return '';
      }
      return database.connectorUrl !== null ? database.connectorUrl : Messages.PermissionsRequired();
    default:
      assertUnreachable(database);
      return '';
  }
}

function getStringForCloudFile(database: DatabaseServerOrPathFragment_CloudFile): string {
  if (database.requestUrl) {
    return database.requestUrl;
  } else if (database.provider && database.fileId) {
    return `${database.provider} ${database.fileId}`;
  } else if (database.provider) {
    return database.provider;
  } else if (database.fileId) {
    return database.fileId;
  } else {
    return '';
  }
}
